// routes.jsx
import { Routes, Route, Navigate } from "react-router-dom";
import AdminPanel from "../layouts/AdminPanel";
import DashboardAdmin from "../pages/dashboard/DashboardAdmin";
import ClientesAdmin from "../pages/customer/ClientesAdmin";
import { NoAutorizado } from "../pages/errors/NoAutorizado";
import RutaProtegida from "../router/RutaProtegida";
import { NoFound } from "../pages/errors/NoFound";
import PasswordRecovery from "../pages/auth/PasswordRecovery";
import { useContext } from "react";
import { AuthContext } from "../context/AuthContext";
import Login from "../pages/auth/Login";
import AjustesAdmin from "../pages/settings/AjustesAdmin";
import UsuariosAdmin from "../pages/users/UsuariosAdmin";
import ModificarVenta from "../pages/sales/ModificarVenta";
import VentasAdmin from "../pages/sales/VentasAdmin";
import ReportadasAdmin from "../pages/reported/ReportadasAdmin";
import Leads from "../pages/leads/index";
import RegistrarReportada from "../pages/reported/RegistrarReportada";
import RegistrarLead from "../pages/leads/RegistrarLead";
import ReporteVentas from "../pages/sales/report/ReporteVentas";
import NuevaVenta from "../pages/sales/NuevaVenta";
import ConsultarVenta from "../pages/sales/ConsultarVenta";
import ProductosAdmin from "../pages/products/ProductosAdmin";
import NuevoProducto from "../pages/products/NuevoProducto";
import ActualizarProducto from "../pages/products/ActualizarProducto";
import ReclutamientoAdmin from "../pages/recruitment/ReclutamientoAdmin";
import NuevoPostulante from "../pages/recruitment/NuevoPostulante";
import UpdatePostulante from "../pages/recruitment/UpdatePostulante";
import EntrevistaForm from "../pages/recruitment/EntrevistaForm";
import RRHHAdmin from "../pages/rrhh/RRHHAdmin";
import NuevoUsuario from "../pages/rrhh/NuevoUsuario";
import LowRequestAdmin from "../pages/lowrequest/LowRequestAdmin";
import AsistenciaAdmin from "../pages/attendance/AsistenciaAdmin";
import SupportAdmin from "../pages/support/SupportAdmin";
import ConsultarSupport from "../pages/support/ConsultarSupport";
import WelcomeAdmin from "../pages/welcome/WelcomeAdmin";
import RegistrarWelcome from "../pages/welcome/RegistrarWelcome";
import ReceiptsAdmin from "../pages/receipts/ReceiptsAdmin";
import RegistrarReceipts from "../pages/receipts/RegistrarReceipts";
import Preloader from "../components/Preloader";
import ReporteConfigAdmin from "../pages/reporteconfig/reporteconfigAdmin";
import RegisterReportConfig from "../pages/reporteconfig/RegisterReporteConfig";
import ReportesDetail from "../pages/reportes/ReportesDetail";
import EditReportConfig from "../pages/reporteconfig/EditReportConfig";

const AppRoutes = () => {
  const { usuario, token, handleLogout, authLoading } = useContext(AuthContext);

  if (authLoading) {
    return <Preloader />;
  }
  return (
    <Routes>
      <Route
        path="/admin"
        element={
          usuario && token ? (
            <AdminPanel
              user={usuario}
              token={token}
              onLogout={handleLogout}
            />
          ) : (
            <Navigate to="/login" replace />
          )
        }
      >
        <Route
          index
          element={
            <RutaProtegida permiso="menu_dashboard">
              <DashboardAdmin />
            </RutaProtegida>
          }
        />
        <Route
          path="usuarios"
          element={
            <RutaProtegida permiso="menu_users">
              <UsuariosAdmin />
            </RutaProtegida>
          }
        />
        <Route
          path="rrhh"
          element={
            <RutaProtegida permiso="menu_rrhh">
              <RRHHAdmin />
            </RutaProtegida>
          }
        />
        <Route
          path="solicitudbaja"
          element={
            <RutaProtegida permiso="menu_low_request">
              <LowRequestAdmin />
            </RutaProtegida>
          }
        />
        <Route
          path="reclutamiento"
          element={
            <RutaProtegida permiso="menu_recruitment">
              <ReclutamientoAdmin />
            </RutaProtegida>
          }
        />
        <Route
          path="reclutamiento/registrar"
          element={
            <RutaProtegida permiso="recruitment_add">
              <NuevoPostulante />
            </RutaProtegida>
          }
        />
        <Route
          path="reclutamiento/:id"
          element={
            <RutaProtegida permiso="recruitment_edit">
              <UpdatePostulante />
            </RutaProtegida>
          }
        />
        <Route
          path="reclutamiento/entrevista/:id"
          element={
            <RutaProtegida permiso="recruitment_entrevistar">
              <EntrevistaForm />
            </RutaProtegida>
          }
        />
        <Route
          path="rrhh/contratar/:id"
          element={
            <RutaProtegida permiso="rrhh_create_user">
              <NuevoUsuario />
            </RutaProtegida>
          }
        />
        <Route
          path="productos"
          element={
            <RutaProtegida permiso="menu_products">
              <ProductosAdmin />
            </RutaProtegida>
          }
        />
        <Route
          path="soporte"
          element={
            <RutaProtegida permiso="menu_soporte">
              <SupportAdmin />
            </RutaProtegida>
          }
        />
        <Route
          path="ventas"
          element={
            <RutaProtegida permiso="menu_sales">
              <VentasAdmin token={token} user={usuario} />
            </RutaProtegida>
          }
        />
        <Route
          path="bienvenida"
          element={
            <RutaProtegida permiso="menu_welcome_web">
              <WelcomeAdmin />
            </RutaProtegida>
          }
        />
        <Route
          path="bienvenida/registrar/:id/:j?"
          element={
            <RutaProtegida permiso="add_follow_welcome">
              <RegistrarWelcome />
            </RutaProtegida>
          }
        />
        <Route
          path="recibos"
          element={
            <RutaProtegida permiso="menu_cobranza">
              <ReceiptsAdmin />
            </RutaProtegida>
          }
        />
        <Route
          path="recibos/registrar/:id/:j?"
          element={
            <RutaProtegida permiso="menu_cobranza">
              <RegistrarReceipts />
            </RutaProtegida>
          }
        />
        <Route
          path="reportadas"
          element={
            <RutaProtegida permiso="menu_reported_web">
              <ReportadasAdmin />
            </RutaProtegida>
          }
        />
        <Route
          path="reporteconfig/:id"
          element={
            <RutaProtegida permiso="menu_reported_web">
              <ReportesDetail />
            </RutaProtegida>
          }
        />
        <Route
          path="reporteconfig/edit/:id"
          element={
            <RutaProtegida permiso="menu_reported_web">
              <EditReportConfig />
            </RutaProtegida>
          }
        />
        <Route
          path="reporteconfig"
          element={
            <RutaProtegida permiso="menu_reported_web">
              <ReporteConfigAdmin />
            </RutaProtegida>
          }
        />
        <Route
          path="reporteconfig/registrar"
          element={
            <RutaProtegida permiso="recruitment_add">
              <RegisterReportConfig />
            </RutaProtegida>
          }
        />
        <Route
          path="reportadas/registrar/:id/:j?"
          element={
            <RutaProtegida permiso="menu_reported_web">
              <RegistrarReportada />
            </RutaProtegida>
          }
        />
        <Route
          path="Leads"
          element={
            <RutaProtegida permiso="leads">
              <Leads />
            </RutaProtegida>
          }
        />
        <Route
          path="leads/registrar/:id/:j?"
          element={
            <RutaProtegida permiso="leads">
              <RegistrarLead />
            </RutaProtegida>
          }
        />
        <Route
          path="reportes"
          element={
            <RutaProtegida permiso="menu_reports">
              <ReporteVentas token={token} />
            </RutaProtegida>
          }
        />
        <Route
          path="asistencia"
          element={
            <RutaProtegida permiso="menu_asistencia">
              <AsistenciaAdmin />
            </RutaProtegida>
          }
        />
        <Route
          path="historial"
          element={
            <RutaProtegida permiso="menu_historial">
              <ReporteVentas token={token} />
            </RutaProtegida>
          }
        />
        <Route
          path="clientes"
          element={
            <RutaProtegida permiso="menu_customers">
              <ClientesAdmin />
            </RutaProtegida>
          }
        />
        <Route
          path="perfiles"
          element={
            <RutaProtegida permiso="menu_settings">
              <AjustesAdmin />
            </RutaProtegida>
          }
        />
        <Route
          path="ventas/:id"
          element={
            <RutaProtegida permiso="update_venta">
              <ModificarVenta token={token} user={usuario} />
            </RutaProtegida>
          }
        />
        <Route
          path="ventas/consultar/:id"
          element={
            <RutaProtegida permiso="consultar_venta">
              <ConsultarVenta token={token} user={usuario} />
            </RutaProtegida>
          }
        />
        <Route
          path="soporte/consultar/:id"
          element={
            <RutaProtegida permiso="view_soporte_detail">
              <ConsultarSupport />
            </RutaProtegida>
          }
        />
        <Route
          path="ventas/registrar"
          element={
            <RutaProtegida permiso="create_venta">
              <NuevaVenta token={token} user={usuario} />
            </RutaProtegida>
          }
        />
        <Route
          path="productos/:id"
          element={
            <RutaProtegida permiso="edit_product">
              <ActualizarProducto />
            </RutaProtegida>
          }
        />
        <Route
          path="productos/registrar"
          element={
            <RutaProtegida permiso="add_products">
              <NuevoProducto />
            </RutaProtegida>
          }
        />
      </Route>
      <Route path="/" element={
        usuario ? (
          <Navigate to="/admin" replace />
        ) : (
          <Login />
        )
      } />
      <Route path="/recuperar-clave" element={<PasswordRecovery />} />
      <Route path="/no-autorizado" element={<NoAutorizado />} />
      <Route path="*" element={<NoFound />} />
    </Routes>
  );
};

export default AppRoutes;
